import ImgCrop, { type ImgCropProps } from 'antd-img-crop';
import { useTranslation } from 'react-i18next';

export type ImageCropperProperties = {
  aspect?: '1:1' | '16:9' | '4:3' | number;
} & Omit<ImgCropProps, 'aspect'>;

const getAspectRatio = (aspect: ImageCropperProperties['aspect']) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  switch (aspect) {
    case '1:1':
      return 1;
    case '16:9':
      return 16 / 9;
    case '4:3':
      return 4 / 3;
    default:
      return aspect;
  }
};

const ImageCropper = ({
  aspect = '16:9',
  children,
  cropShape = 'rect',
  modalWidth = 520,
  quality = 1,
  rotationSlider = true,
  showGrid = true,
  showReset = true,
  ...rest
}: ImageCropperProperties) => {
  const { t } = useTranslation();

  return (
    <ImgCrop
      aspect={getAspectRatio(aspect)}
      cropShape={cropShape}
      modalOk={t('Save')}
      modalTitle={t('Crop your image')}
      modalWidth={modalWidth}
      quality={quality}
      rotationSlider={rotationSlider}
      showGrid={showGrid}
      showReset={showReset}
      {...rest}
    >
      {children}
    </ImgCrop>
  );
};

export default ImageCropper;
